import { useTranslation } from "react-i18next";

export default function SupportCrumb(): string {
  const { t } = useTranslation();
  return t("menu.Support");
}
